import axios from "axios";
import {useQuery} from "@tanstack/vue-query";

const getBacklinkHealthcheck = (maxDomainAuthority) =>  useQuery({
  queryKey: ['healthcheck', {maxDomainAuthority}],
  queryFn: async () => {
    const query = new URLSearchParams();
    query.append('maxDomainAuthority', maxDomainAuthority.value);

    const { data } = await axios.get(`/ajax/v2/backlinks/healthcheck?` + query.toString());

    return data.data;
  },
});


export {
  getBacklinkHealthcheck,
}
